import { PicklistAssemblies } from './PicklistAssemblies';

export default PicklistAssemblies;
